import { render, staticRenderFns } from "./addThemeColor.vue?vue&type=template&id=b5d12640&lang=pug"
import script from "./addThemeColor.vue?vue&type=script&lang=js"
export * from "./addThemeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports